import { Box } from '@mui/material';

import { ListingAccordion } from '@modules/_shared/components/ListingAccordion';
import { UserBuyersLeadKanban } from '@modules/users/components/UserBuyerLeadsKanban';
import { UserBuyerLeadsCard } from '@modules/users/user-overview/components/UserBuyerLeadsCard';
import { UserLeadsCard } from '@modules/users/user-overview/components/UserLeadsCard';
import { UserPropertySearchCard } from '@modules/users/user-overview/components/UserPropertySearchCard';
import { useLocale } from '@shared/hooks/locale';

type UserBuyingProps = {
  userId: string;
};

export const UserBuying = ({ userId }: UserBuyingProps) => {
  const { t } = useLocale();

  return (
    <Box
      sx={{
        p: 2,
        maxWidth: 1400,
        mx: 'auto',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        '& .MuiAccordion-root.Mui-expanded': { margin: 0 },
      }}
    >
      <UserLeadsCard userId={userId} variant="buying" hideWhenEmpty />

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 2,
          alignItems: 'flex-start',
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0, width: { xs: '100%', md: 'auto' } }}>
          <UserBuyerLeadsCard userId={userId} />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0, width: { xs: '100%', md: 'auto' } }}>
          <UserPropertySearchCard userId={userId} />
        </Box>
      </Box>

      <ListingAccordion
        title={t('Buyer leads matching')}
        defaultExpanded
        disablePadding
      >
        <Box
          sx={{
            minHeight: 480,
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
          }}
        >
          <UserBuyersLeadKanban userId={userId} />
        </Box>
      </ListingAccordion>
    </Box>
  );
};
